module.exports = __webpack_public_path__ + "static/Nahuel-1da9d478e6ade5d54ffa26e425e1e3bd.png";